export const maxData = {
  variantA: {
    title: "Max w pakiecie Standard",
    price: "29,99",
    badge: "Dost\u0119p do Premium do 31.07.2025",
    highlightText: "Kup abonament i wybierz dost\u0119p do Max<br/> w ostatnim kroku zam\xF3wienia.",
    additionalOffer: [
      {
        text: "Max w pakiecie Standard"
      }
    ]
  },
  variantB: {
    title: "All In Streaming",
    price: "84",
    badge: "Dost\u0119p do Premium do 31.07.2025",
    highlightText: "Kup abonament i wybierz dost\u0119p do Max<br/> w ostatnim kroku zam\xF3wienia.",
    additionalOffer: [{ text: "Max w pakiecie Standard" }, { text: "Disney+" }, { text: "Polsat Box Go" }]
  }
};
export const appleOneData = {
  variantA: {
    title: "Dla rodziny",
    price: "39,99",
    badge: "1 MIESI\u0104C GRATIS",
    additionalOffer: [
      { text: "Apple Music" },
      { text: "Apple TV+" },
      { text: "Apple Arcade" },
      { text: "iCloud+", badge: "200 GB" }
    ]
  },
  variantB: {
    title: "Dla Ciebie",
    price: "49,99",
    badge: "1 MIESI\u0104C GRATIS",
    secondaryText: "Dost\u0119p dla Ciebie i nawet pi\u0119ciu innych os\xF3b",
    additionalOffer: [
      { text: "Apple Music" },
      { text: "Apple TV+" },
      { text: "Apple Arcade" },
      { text: "iCloud+", badge: "50 GB" }
    ]
  }
};
